/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetOptions200ResponseData } from './GetOptions200ResponseData'
import {
  GetOptions200ResponseDataFromJSON,
  GetOptions200ResponseDataFromJSONTyped,
  GetOptions200ResponseDataToJSON,
} from './GetOptions200ResponseData'

/**
 *
 * @export
 * @interface GetOptions200Response
 */
export interface GetOptions200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetOptions200Response
   */
  status: boolean
  /**
   *
   * @type {GetOptions200ResponseData}
   * @memberof GetOptions200Response
   */
  data: GetOptions200ResponseData
}

/**
 * Check if a given object implements the GetOptions200Response interface.
 */
export function instanceOfGetOptions200Response(
  value: object
): value is GetOptions200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetOptions200ResponseFromJSON(
  json: any
): GetOptions200Response {
  return GetOptions200ResponseFromJSONTyped(json, false)
}

export function GetOptions200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOptions200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOptions200ResponseDataFromJSON(json['data']),
  }
}

export function GetOptions200ResponseToJSON(
  value?: GetOptions200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetOptions200ResponseDataToJSON(value['data']),
  }
}
